import ACTIONS from "../actions/types";

export default function (state = null, action) {
  switch (action.type) {
    case ACTIONS.SET_PAGE_IDS:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
